export default __webpack_public_path__ + "static/media/shift-insight.35f96892.svg";